import { render, staticRenderFns } from "./Badge12.vue?vue&type=template&id=576c889b&scoped=true"
import script from "./Badge12.vue?vue&type=script&lang=js"
export * from "./Badge12.vue?vue&type=script&lang=js"
import style0 from "./Badge12.vue?vue&type=style&index=0&id=576c889b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "576c889b",
  null
  
)

export default component.exports